import type { AccountConfiguration } from "../store/schema/OwaSessionStore";

export const makeEmptyAccountConfiguration = (): AccountConfiguration => ({
    defaultFolderNameToIdMap: new Map(),
    defaultFolderIdToNameMap: new Map(),
});
